<template>
    <page :title="isEditMode ? 'updateRecordSetTitle' : 'newRecordSetTitle'" :textHeight="getWindowHeight">
        <template #pageContainer>
            <v-form ref="form" v-model="valid">
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.name')"
						v-model="form.name"
						:error-messages="errors('name')"
						required
						@input="$v.form.name.$touch()"
						@blur="$v.form.name.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.recordCode')"
						v-model="form.code"
						:error-messages="errors('code')"
						:rules="[rules.maxLen6]"
						required
						@input="$v.form.code.$touch()"
						@blur="$v.form.code.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="loading"
						clearable
						v-model="form.nationalClassShort"
						:items="classesSelector"
						:label="$t('text.class')"
						:error-messages="errors('class')"
						:loading="loading"
						@change="classSelected"
						@input="$v.form.nationalClassShort.$touch()"
						@blur="$v.form.nationalClassShort.$touch()">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.startAge')"
						v-model="form.startAge"
						:error-messages="errors('startAge')"
						required
						@input="$v.form.startAge.$touch()"
						@blur="$v.form.startAge.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-text-field outlined dense
						hide-details="auto"
						:label="$t('text.endAge')"
						v-model="form.endAge"
						:error-messages="errors('endAge')"
						required
						@input="$v.form.endAge.$touch()"
						@blur="$v.form.endAge.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="loading"
						v-model="form.gender"
						:items="gender"
						:label="$t('text.genderLable')"
						:error-messages="errors('gender')"
						:loading="loading"
						@input="$v.form.gender.$touch()"
						@blur="$v.form.gender.$touch()">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="loading"
						v-model="form.recordType"
						:items="recordType"
						:label="$t('text.recordTypeLable')"
						:error-messages="errors('recordType')"
						:loading="loading"
						@input="$v.form.recordType.$touch()"
						@blur="$v.form.recordType.$touch()">
					</v-autocomplete>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="loading"
						v-model="form.recordValidity"
						:items="recordValidity"
						:label="$t('text.recordValidityLable')"
						:error-messages="errors('recordValidity')"
						:loading="loading"
						@input="$v.form.recordValidity.$touch()"
						@blur="$v.form.recordValidity.$touch()">
					</v-autocomplete>
				</v-col></v-row>
				<v-row v-if="form.recordValidity !== 1"><v-col>
					<v-autocomplete outlined dense
						v-if="form.recordValidity === 4"
						hide-details="auto"
						:disabled="loading"
						v-model="form.validityQualifier"
						:items="validityQualifier"
						:label="$t('text.recordValidityLable')"
						:error-messages="errors('validityQualifier')"
						:loading="loading"
						@input="$v.form.validityQualifier.$touch()"
						@blur="$v.form.validityQualifier.$touch()">
					</v-autocomplete>
					<v-text-field outlined dense v-else
						hide-details="auto"
						:label="$t('text.validityQualifierLable')"
						v-model="form.validityQualifier"
						:error-messages="errors('validityQualifier')"
						required
						@input="$v.form.validityQualifier.$touch()"
						@blur="$v.form.validityQualifier.$touch()">
					</v-text-field>
				</v-col></v-row>
				<v-row><v-col>
					<c-checkbox type="checkbox"
						:text="$t('text.multiRecordLable')"
						v-model="form.isMultiRecord">
					</c-checkbox>
				</v-col></v-row>
				<v-row><v-col>
					<v-autocomplete outlined dense
						hide-details="auto"
						:disabled="loading"
						v-model="form.eventEnvironment"
						:items="environment"
						:label="$t('text.environment')"
						:error-messages="errors('environment')"
						:loading="loading"
						@input="$v.form.eventEnvironment.$touch()"
						@blur="$v.form.eventEnvironment.$touch()">
					</v-autocomplete>
				</v-col></v-row>
            </v-form>
            <spinner :loading="loading"></spinner>
        </template>
		<template #pageActions>
			<v-row><v-col>
				<v-btn v-if="!isEditMode"
					class="mr-4"
					:loading="loading"
					:disabled="$v.$invalid  || loading || !valid"
					@click="createAndBack">
					{{ $t(`text.createButton`) }}
				</v-btn>
				<v-btn v-else
					class="mr-4"
					:loading="loading"
					:disabled="$v.$invalid || loading || !valid"
					@click="createAndBack">
					{{ $t(`text.updateButton`) }}
				</v-btn>
				<v-btn
					:disabled="loading"
					class="mr-4"
					@click="back">
					{{ $t(`text.backButton`) }}
				</v-btn>
			</v-col></v-row>
		</template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';


import Page from '../general/Page.vue';
import Spinner from '../general/Spinner.vue';
import CCheckbox from '../general/CCheckbox.vue';

import recordsActions from '../store/actions/records';
import definitionsActions from '../store/actions/definitions';
import namespace from '../store/namespace';

import modelState from '../mixins/modelState';
import validationRules from '../mixins/validationRules';

import getGenderSelectorList from '../models/gender';
import getRecordType from '../models/recordType';
import getRecordValidity from '../models/recordValidity';
import getEnvSelectorList from '../models/environmentSelector';
import getIOC from '../models/IOC';

export default {
	name: 'NewRecordSet',
	components: {
		Page,
		Spinner,
		CCheckbox,
	},
	mixins: [modelState, validationRules],
	validations: {
		form: {
			name: {
				required,
			},
			code: {
				required,
			},
			nationalClassShort: {
				required,
			},
			startAge: {
				required,
			},
			endAge: {
				required,
			},
			gender: {
				required,
			},
			recordType: {
				required,
			},
			recordValidity: {
				required,
			},
			validityQualifier: {
				// eslint-disable-next-line func-names
				required: requiredIf(function () {
					return this.form.recordValidity !== 1;
				}),
			},
			isMultiRecord: {
				required,
			},
			eventEnvironment: {
				required,
			},
		},
	},
	data() {
		return {
			form: {
				name: '',
				code: '',
				nationalClassShort: '',
				startAge: 0,
				endAge: 0,
				gender: 0,
				recordType: 1,
				recordValidity: 1,
				validityQualifier: '',
				isMultiRecord: false,
				eventEnvironment: 0,
			},
			valid: false,
			loading: false,
			id: this.$route.params.id || null,
		};
	},
	watch: {
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.ORGANIZATION, ['Organization']),
		...mapGetters(namespace.RECORDS, ['RecordSetLinks']),
		...mapGetters(namespace.DEFINITIONS, ['Classes', 'DefinitionsLinks']),
		...mapGetters(namespace.ERROR, ['HasError']),
		getWindowHeight() {
			const errorMargin = this.HasError ? 56 : 0;
			return `${this.WindowSize.y - 276 - errorMargin}px`;
		},
		isEditMode() {
			return !!this.id;
		},
		gender() {
			return getGenderSelectorList(this);
		},
		recordType() {
			return getRecordType(this);
		},
		recordValidity() {
			return getRecordValidity(this);
		},
		classesSelector() {
			return this.Classes.map(x => ({ text: x.longname, value: x.short }));
		},
		validityQualifier() {
			return getIOC();
		},
		environment() {
			return getEnvSelectorList(this);
		},
	},
	async mounted() {
		await this.loadData();
		if (this.isEditMode) {
			await this.getRecordSetById();
		}
	},
	methods: {
		...mapActions(namespace.RECORDS, [
			recordsActions.GET_RECORDSET_LINKS,
			recordsActions.GET_RECORDSETBYID,
			recordsActions.ADD_RECORDSET,
			recordsActions.UPDATE_RECORDSET,
		]),
		...mapActions(namespace.DEFINITIONS, [
			definitionsActions.GET_CLASSES,
			definitionsActions.GET_DEFINITIONS_LINKS,
		]),
		async loadData() {
			this.loadData = true;
			try {
				if (!this.RecordSetLinks.length) {
					await this.getRecordSetLinks();
				}
				if (!this.DefinitionsLinks.length) {
					await this.getDefinitionLinks();
				}
				const link = this.DefinitionsLinks.find(x => x.rel === 'get_all_classes');
				if (link) {
					await this.GET_CLASSES(link);
				}
			} catch (ex) {
				console.log(ex);
			}

			this.loading = false;
		},
		async getRecordSetLinks() {
			try {
				await this.GET_RECORDSET_LINKS();
			} catch (ex) {
				console.log(ex);
			}
		},
		async getDefinitionLinks() {
			try {
				await this.GET_DEFINITIONS_LINKS();
			} catch (ex) {
				console.log(ex);
			}
		},
		async createAndBack() {
			await this.create();
			this.$router.push({
				name: 'recordsets',
			});
		},
		async create() {
			this.loading = true;
			this.$v.$touch();
			this.$refs.form.validate();

			if (!this.$v.$invalid && this.valid) {
				try {
					this.modelState = {};
					if (this.isEditMode) {
						await this.UPDATE_RECORDSET({ recordset: this.form, setId: this.id });
					} else {
						await this.ADD_RECORDSET(({ recordset: this.form, masterOrgId: this.Organization }));
					}
				} catch (e) {
					if (e.response.status === 422) {
						this.modelState = e.response.data;
						if (this.modelError()) {
							throw new Error(this.modelError());
						}
					}

					throw e;
				} finally {
					this.loading = false;
				}
			} else if (!this.valid && this.$refs.form.errorBag) {
				const id = Object.entries(this.$refs.form.errorBag).find(x => x[1] == true)[0];
				if (id) document.getElementById(`input-${id}`).scrollIntoView();
			}
			this.loading = false;
		},
		back() {
			this.$router.push({
				name: 'recordsets',
			});
		},
		async getRecordSetById() {
			this.loading = true;
			try {
				const recordSet = await this.GET_RECORDSETBYID(this.id);

				if (recordSet) {
					this.form = recordSet;
				}
			} finally {
				this.loading = false;
			}
		},
		errors(name) {
			const errors = [];
			const apiErrors = this.validateProperty(name);
			if (apiErrors.length > 0) {
				errors.push(apiErrors);
			}

			return errors;
		},
		classSelected() {
			const selectedClass = this.Classes.find(x => x.short === this.form.nationalClassShort);
			if (selectedClass) {
				this.form.startAge = selectedClass.from;
				this.form.endAge = selectedClass.to;
				this.form.gender = selectedClass.gender;
			}
		},
	},
};
</script>
